/**
 * @generated SignedSource<<b8756058071c6e2aa033e004385b8fe9>>
 * @relayHash 587c7ad278e718587d1eac4df14771a6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 65386b5cc439dde8aa9d8aad5346237b5ab00088b7ae11ef655f90fe865a542a

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraFieldOptionIdsFilterOperation = "ALLOW" | "EXCLUDE" | "%future added value";
export type JiraFieldOptionIdsFilterInput = {
  operation: JiraFieldOptionIdsFilterOperation;
  optionIds: ReadonlyArray<string>;
};
export type resolutionQuery$variables = {
  ari: string;
  filterById?: JiraFieldOptionIdsFilterInput | null | undefined;
};
export type resolutionQuery$data = {
  readonly node: {
    readonly resolutions?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly label: string | null | undefined;
          readonly value: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type resolutionQuery = {
  response: resolutionQuery$data;
  variables: resolutionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ari"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterById"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "ari"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "filterById",
    "variableName": "filterById"
  }
],
v3 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "resolutionQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "JiraResolutionConnection",
                "kind": "LinkedField",
                "name": "resolutions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraResolutionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraResolution",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "JiraResolutionField"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "resolutionQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "JiraResolutionConnection",
                "kind": "LinkedField",
                "name": "resolutions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraResolutionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraResolution",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "JiraResolutionField"
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "65386b5cc439dde8aa9d8aad5346237b5ab00088b7ae11ef655f90fe865a542a",
    "metadata": {},
    "name": "resolutionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e47e170049dc135e17b0bba21ecce5ac";

export default node;
